import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_USERS_API_URL
});

export default {
    
}